import { useEffect, useState } from "react";
import {
    useLocation,
} from "react-router-dom";
import { useTranslation } from "react-i18next";
import { postEngageDAGC } from "../../services/ads/ads.service";

// import { links } from "../../constants/links";
// import { Loading } from "../../components";
import Text from "../../components/Text";
// import httpClient from "../../configs/http-client";
// import apiUrl from "../../constants/apiUrl";


const DAGC = () => {
    const location = useLocation();

    const { t } = useTranslation();

    const subCampaignId: String = location?.state?.subcampaign_id;

    const [errorMessage, setErrorMessage] = useState("");
    const [deepLink, setDeepLink] = useState("");

    useEffect(() => {
        postEngageDAGC(subCampaignId)
            .then(response => {
                if (response.status === 200 && response.data) {
                    const { dagc_session_id, app_name } = response.data;
                    const newDeepLink =  `${window.location.origin}/download/${app_name}?dagc_session_id=${dagc_session_id}&qualification=true`;
                    setDeepLink(newDeepLink);
                    // const anchorEl = document.createElement("a");
                    // anchorEl.setAttribute("target", "_blank");
                    // anchorEl.setAttribute("rel", "noopener noreferrer");
                    // anchorEl.setAttribute("href", deepLink);
                    // anchorEl.click();

                    // navigate(links.DOWNLOAD.replace(":app_name", app_name) + "?dagc_session_id=" + dagc_session_id)
                }
            })
            .catch(error => {
                if (error.response) {
                    setErrorMessage(error.response.data.msg_code);
                }
                console.error(error);
            });
    }, [subCampaignId]);

    function navigateToDeeplink() {
        window.location.href = deepLink;
    }

    return (
        <div style={{ position: "fixed", width: "100%", top: "50%", left: 0, textAlign: "center", zIndex: 10000 }}>
            <p style={{ marginTop: "1rem" }}>
                <a href="https://sit-global-se.sp.smartretail.co/download/fontboard?dagc_session_id=1fc83ba9-5dee-4bf7-acda-0836479033d5&qualification=true">Hardcoded Link</a>
            </p>
            {deepLink && (
                <>
                    <button onClick={() => navigateToDeeplink()} style={{
                        fontSize: "2rem",
                        background: "black",
                        color: "white",
                        border: "none",
                        padding: "1rem",
                        marginTop: "1rem",
                    }}>CLICK TO DOWNLOAD</button>
                    <p style={{ marginTop: "1rem" }}>
                        <a href={deepLink}>Generated Link</a>
                    </p>
                </>
            )}
            {errorMessage && (
                <div style={{ position: "fixed", width: "100%", fontSize: "2rem", top: "50%", left: 0, textAlign: "center", zIndex: 10000 }}>
                    <Text>{t(errorMessage)}</Text>
                </div>
            )}
        </div>
    );
};

export default DAGC;
